import client from '../httpClient';

// webRes003
const webResDeleteApi = (responseId, isShowLoading = true) => {
  return client.delete(`/responses/${responseId}`, { isShowLoading, isShowMessage: true });
};

export default webResDeleteApi;
